<app-sales-simulator-kredicash-embedded-v3
  *ngIf="isFlowKrdya"
  [mode]="mode"
  [initialProducts]="initialProducts"
  [initialSalary]="initialSalary"
  [externalCategoryId]="externalCategoryId"
  [requestId]="requestId"
  (nextStepEvent)="onNextStep()"
  (modalSaveEvent)="modalSaveEvent.emit($event)">
</app-sales-simulator-kredicash-embedded-v3>

<app-sales-simulator-kredicash-embedded-v2
  *ngIf="!isFlowKrdya"
  [mode]="mode"
  [initialProducts]="initialProducts"
  [initialSalary]="initialSalary"
  [externalCategoryId]="externalCategoryId"
  [requestId]="requestId"
  (nextStepEvent)="onNextStep()"
  (modalSaveEvent)="modalSaveEvent.emit($event)">
</app-sales-simulator-kredicash-embedded-v2>
